export default __webpack_public_path__ + "static/media/pinterest.1e51b1eb.svg";